<template>
	<!-- Welcome !-->
	<router-link :to="to"
				 class="px-2.5 py-2 group flex flex-shrink-0 items-center text-sm leading-5 font-medium rounded-md hover:text-white hover:bg-white hover:bg-opacity-10 focus:outline-none focus:bg-white focus:bg-opacity-10 transition ease-in-out duration-150 group"
				 v-bind="linkClass">
		<i class="w-6 m-1 flex-shrink-0 text-center text-lg transition ease-in-out duration-150" :class="icon"></i>
		<OpacityScaleTransition enter-extra="-translate-x-8">
			<span v-if="!compact" class="ml-3">{{ title }}</span>
		</OpacityScaleTransition>
		<OpacityScaleTransition enter-extra="-translate-x-8">
			<div v-if="compact" class="hidden absolute left-1 z-30 flex px-3 py-1 bg-white border shadow group-hover:flex rounded items-center space-x-2">
				<i class="w-6 m-1 flex-shrink-0 text-center text-xl transition ease-in-out duration-150 text-turquoise" :class="icon"></i>
				<p class="text-gray-500">{{ title }}</p>
			</div>
		</OpacityScaleTransition>
	</router-link>
</template>
<script>
import OpacityScaleTransition from "@/components/OpacityScaleTransition.vue"

export default {
	name: "SidebarMenuItem",
	components: { OpacityScaleTransition },
	props: {
		title: {
			type: String,
			required: true
		},
		to: {
			type: [String, Object],
			required: true
		},
		icon: {
			type: String,
			required: true
		},
		showLabel: false,
		activeOnExact: Boolean,
		compact: Boolean
	},
	computed: {
		linkClass() {
			return this.activeOnExact ? { "exact-active-class": "bg-opacity-50 bg-gray-900 text-white" } : { "active-class": "bg-opacity-50 bg-gray-900 text-white" }
		}
	}
}
</script>